import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import styles from "../../../src/components/common/css/Header.module.css";
import IcoDown from "../../assets/img/IcoDown";
import { useAlert } from "../../shared/components/AlertProvider";
import Button from "../../shared/components/Button";
import Card from "../../shared/components/Card";
import CheckBox from "../../shared/components/CheckBox";
import CommonSelect from "../../shared/components/CommonSelect";
import Flex from "../../shared/components/Flex";
import LabelInput from "../../shared/components/LabelInput";
import LabelTextArea from "../../shared/components/LabelTextArea";
import Padding from "../../shared/components/Padding";
import Spacer from "../../shared/components/Spacer";
import Text from "../../shared/components/Text";
import { responseMsg } from "../common/ResponseMsg";
import Loading from "../../shared/components/Loading";
import useDelayedLoading from "../../shared/hooks/useDelayedLoading";
import useDevice from "../../shared/hooks/useDevice";

function Contact({name}) {
    const { register, handleSubmit, formState: { isSubmitting, isDirty, errors }} = useForm();
    const navigate = useNavigate();
    const [selectedInquiries, setSelectedInquiries] = useState('고장신고');
    const [isDrop, setIsDrop] = useState(false);
    const [agree, setAgree] = useState(false);
    const showAlert = useAlert();
    const [lock, setLock] = useState(false);
    const device = useDevice();
    const isMobile = device === "mobile";

    const inquiriesOption = [
        { text: '고장신고', value:'고장신고'},
        { text: '데이터요청', value:'데이터요청'},
        { text: '설치문의', value:'설치문의'},
        { text: '기타', value:'기타'},
    ]

    const handleCellNoChange = (e) => {
        const value = e.target.value;
        // 숫자와 대시만 허용
        const filteredValue = value.replace(/[^0-9-]/g, '');
        if (value !== filteredValue) {
            e.target.value = filteredValue;
        }
    };

    const autoHyphen = (target) => {
        target.value = target.value
            .replace(/[^0-9]/g, '')
            .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3").replace(/(\-{1,2})$/g, "");
    }

    const onSubmit = (formData) => {
        if (lock) return;

        if (!agree) {
            showAlert({title: "주의", text: "개인정보 수집 및 이용에 동의해 주세요.", type: "warning"})
            return;
        } else if (formData.userName.trim() === '') {
            showAlert({title: "주의", text: "이름을 입력해 주세요.", type: "warning"})
            return;
        } else if (formData.userTel.trim() === '') {
            showAlert({title: "주의", text: "휴대전화를 입력해 주세요.", type: "warning"})
            return;
        } else if (formData.userEmail.trim() === '') {
            showAlert({title: "주의", text: "이메일을 입력해 주세요.", type: "warning"})
            return;
        } else if (formData.userName.trim() === '') {
            showAlert({title: "주의", text: "문의항목을 선택해 주세요.", type: "warning"})
            return;
        } else if (formData.request.trim() === '') {
            showAlert({title: "주의", text: "요청사항을 입력해 주세요.", type: "warning"})
            return;
        }

        setLock(true);

        fetch("/api/contact", {
            method : 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({...formData,inquiries:selectedInquiries})
        })
            .then((res) => res.json())
            .then((json) => {
                if(json.code === responseMsg.SUCCESS.code) {
                    showAlert({title: "알림", text: "답변은 해당 이메일로 전달됩니다."})
                    navigate('/main');
                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setLock(false);
            });
    }

    const isLoadingComponent = useDelayedLoading(500);

    return (
        <>
        <Loading isLoading={isLoadingComponent} minDuration={300} message="Loading..."/>
            <Padding paddingTop={50} paddingBottom={60} paddingX={0} style={{ userSelect: "none"}}>
                <Flex flexDirection="column" alignItems="center" gap={25}>
                    <Text size={40} weight={'bold'}>문의접수</Text>
                    <Text size={20} weight={'regular'}>궁금하신 점을 작성해주시면 빠르게 안내해드립니다.</Text>
                    <Card width={isMobile ? "95%" : 700}>
                        <Padding padding={60}>
                            <form>
                                <Flex flexDirection="column" gap={25}>
                                    <Flex flexDirection={isMobile ? "column" : "row"} gap={20}>
                                        <LabelInput label="이름" fullWidth placeholder="이름을 입력해 주세요" required autoFocus {...register("userName")} />
                                        <LabelInput label="휴대전화" fullWidth placeholder="번호를 입력해 주세요" required {...register("userTel",{
                                            onChange: ({ target }) => autoHyphen(target),
                                        })} maxLength={13} />
                                    </Flex>
                                    <Flex flexDirection={isMobile ? "column" : "row"} gap={20}>
                                        <LabelInput label="이메일" fullWidth placeholder="이메일을 입력해 주세요" required {...register("userEmail")} />
                                        <CommonSelect label='문의항목' isModal fullWidth value={selectedInquiries} data={inquiriesOption} onChange={setSelectedInquiries} required/>
                                    </Flex>
                                    <LabelTextArea label='요청사항' placeholder="요청사항을 입력해 주세요" rows={5} required {...register("request")} />
                                </Flex>
                                <Spacer direction="vertical" size={30} />
                                <Flex justifyContent="space-between" alignItems="center">
                                    <Flex gap={10} alignItems="center">
                                        <CheckBox
                                            id="agree"
                                            checked={agree}
                                            onChange={(e) => setAgree(e.target.checked)}
                                        />

                                        <label
                                            htmlFor="agree"
                                            style={{
                                                display: "flex",
                                                gap: 5,
                                                alignItems: "center",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <Text variant="span" textAlign="center">개인정보 수집 및 이용 동의</Text>
                                            <Text variant="span" textAlign="center" color="red">(필수)</Text>
                                        </label>
                                    </Flex>

                                    <div onClick={() => setIsDrop(!isDrop)} style={{cursor: "pointer"}}>
                                        <IcoDown className={isDrop ? styles.caretOpen : styles.caret} />
                                    </div>
                                </Flex>
                                {isDrop && (
                                    <>
                                        <Spacer direction="vertical" size={10} />
                                        <Card backgroundColor="#F5F5F5">
                                            <Padding paddingX={20} paddingY={15} >
                                                <Flex flexDirection="column" gap={8}>
                                                    <Text size={14} weight={'regular'} color="#555555">개인정보 수집 이용 동의서</Text>
                                                    <Text size={14} weight={'regular'} color="#555555">1. 개인정보 수집, 이용 기관명:</Text>
                                                    <Text size={14} weight={'regular'} color="#555555">2. 개인정보 수집, 이용범위와 사용목적</Text>
                                                    <Text size={14} weight={'regular'} color="#555555">- 수집, 이용 범위: 이름, 연락처, 이메일</Text>
                                                    <Text size={14} weight={'regular'} color="#555555">- 사용목적: 고객문의 답변 안내</Text>
                                                </Flex>
                                            </Padding>
                                        </Card>
                                    </>
                                )}
                            </form>
                            <Spacer direction="vertical" size={40} />
                            <Button fullWidth height={55} borderRadius={14} backgroundColor="#EE7D00" onClick={handleSubmit(onSubmit)} isLock={lock}>
                                <Text variant="span" size={18} weight={'bold'} color="white">전송</Text>
                            </Button>
                        </Padding>
                    </Card>
                </Flex>
            </Padding>
            </>
    );
}

export default Contact;